export enum QuestionTypeEnum {
  单选题 = 1,
  多选题,
  不定项,
  论述题,
  填空题,
  判断题,
}
